module.exports = __webpack_public_path__ + "img/emo_31.dd3ba3d1.png";